import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get dimension
export const getDimension = createAsyncThunk("dimension/getDimension", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getDimension({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all dimension
export const getAllDimension = createAsyncThunk("dimension/getAllDimension", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllDimension();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("dimension/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("dimension/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "dimension/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageDimension({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create dimension
export const createDimension = createAsyncThunk("dimension/createDimension", async (data, { rejectWithValue }) => {
  const { name, description, code, isActive } = data;
  try {
    const body = JSON.stringify({ name, description, code, isActive });
    const { data } = await API.createDimension(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateDimension = createAsyncThunk("dimension/updateDimension", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, description, code, isActive } = values;
  try {
    const body = JSON.stringify({ name, description, code, isActive });
    const { data } = await API.updateDimension(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("dimension/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getDimension({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
